import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getSummary() {
        try
        {            
            const response = await axios.get(`CashAdvances`,
            {
                headers: {
                    'page_key': pageKeys.cash_advances
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Cash Advances getSummary api error')
            throw error
        }
    },    
    async getMyCashAdvances() {
        try
        {            
            const response = await axios.get(`CashAdvances/mycashadvances`,
            {
                headers: {
                    'page_key': pageKeys.my_cash_advances
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Cash Advances getMyCashAdvances api error')
            throw error
        }
    },
    async setForReview(data, pageKey) {
        try
        {            
            const response = await axios.post(`CashAdvances/forreview`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Cash Advances setForReview api error')
            throw error
        }
    },
    async approve(data) {
        try
        {            
            const response = await axios.post(`CashAdvances/approve`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.cash_advances
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Cash Advances approve api error')
            throw error
        }
    },
    async reject(data) {
        try
        {            
            const response = await axios.post(`CashAdvances/reject`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.cash_advances
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Cash Advances reject api error')
            throw error
        }
    },
    async getDetail(cashAdvancesId) {
        try
        {            
            const response = await axios.get(`CashAdvances/${cashAdvancesId}`,
            {
                headers: {
                    'page_key': pageKeys.cash_advances
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Cash Advances getDetail api error')
            throw error
        }
    },
    async getMyCashAdvancesDetail(cashAdvancesId) {
        try
        {           
            const response = await axios.get(`CashAdvances/${cashAdvancesId}`,
            {
                headers: {
                    'page_key': pageKeys.my_cash_advances
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Cash Advances getMyCashAdvancesDetail api error')
            throw error
        }
    },
    async getTypes() {
        try
        {            
            const response = await axios.get(`CashAdvances/types`,
            {
                headers: {
                    'page_key': pageKeys.my_cash_advances
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Cash Advances getTypes api error')
            throw error
        }
    },
    async add(data, pageKey) {
        try
        {            
            const response = await axios.post(`CashAdvances`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Cash Advances add api error')
            throw error
        }
    },
    async update(data, pageKey) {
        try
        {            
            const response = await axios.patch(`CashAdvances`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Cash Advances update api error')
            throw error
        }
    },
    async fundReleased(data) {
        try
        {            
            const response = await axios.post(`CashAdvances/fund-released`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.cash_advances
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Cash Advances fundReleased api error')
            throw error
        }
    },
    async getDepositSlip(cashAdvancesId) {
        try
        {        
            const response = await axios.get(`CashAdvances/deposit-slip/${cashAdvancesId}`,
            {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.cash_advances
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getDepositSlip error')
            throw error
        }
    },
    async delete(data) {
        try
        {            
            const response = await axios.post(`CashAdvances/delete`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.cash_advances
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Cash Advances delete api error')
            throw error
        }
    },
    async updateSchedule(data) {
        try
        {            
            const response = await axios.post(`CashAdvances/schedule`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.cash_advances
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Cash Advances updateSchedule api error')
            throw error
        }
    },    
    async scheduleOnHold(data) { //not used
        try
        {            
            const response = await axios.post(`CashAdvances/schedule/onhold`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.cash_advances
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Cash Advances scheduleOnHold api error')
            throw error
        }
    },
}
